export default function PublicFooter() {
    return (
        <footer data-testid="public-footer" className="bg-[#0F172A] text-white mt-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-5">
                        <div className="h-12 w-12 bg-black flex items-center justify-center overflow-hidden">
                            <img src="https://customer-assets.emergentagent.com/job_form-manage/artifacts/dwtsdzv7_WhatsApp%20Image%202026-05-25%20at%208.11.14%20PM.jpeg" alt="STMF" className="h-full w-full object-cover" />
                        </div>
                        <div>
                            <div className="font-display font-bold tracking-tight">STMF</div>
                            <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">Est. 1987</div>
                        </div>
                    </div>
                    <p className="text-sm text-white/70 max-w-md leading-relaxed">
                        Surat Texmac Federation — the apex industry body representing textile machinery
                        manufacturers, traders and technical service providers across India.
                    </p>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.15em] text-[#D4AF37] mb-4">Navigate</div>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><a href="/">Home</a></li>
                        <li><a href="/events">Events</a></li>
                        <li><a href="/apply">Apply</a></li>
                        <li><a href="/admin/login">Admin Portal</a></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.15em] text-[#D4AF37] mb-4">Contact</div>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li>Surat, Gujarat, India</li>
                        <li>info@stmfindia.com</li>
                        <li>stmfindia.com</li>
                        <li>+91 98765 43210</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
                    <div>Copyright © 2026 Surat Texmac Federation — All Rights Reserved.</div>
                    <div>Trusted Dealers · Reliable Technology · Strong Industry</div>
                </div>
            </div>
        </footer>
    );
}
